import { useEffect } from "react";
import CustomerDropdown from "../components/CustomerDropdown";
import ResourceDropdown from "../components/ResourceDropdown";
import { DateRangePicker } from "../components/ui/daterange-picker";
import { useLazyGetUtilizationDashboardQuery } from "../store/api/dashboardApi";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from "../components/ui/card";
import Chart from "react-apexcharts";

export default function UtilizationDashboard({ instanceId }) {
  const [fetchDashboard, { data }] = useLazyGetUtilizationDashboardQuery();

  useEffect(() => {
    fetchDashboard();
  }, []);

  return (
    <div className="space-y-4">
      <div className="flex space-x-2">
        <CustomerDropdown />
        <ResourceDropdown />
        <DateRangePicker />
      </div>
      <div>{data && <MetricsDashboard data={data} />}</div>
    </div>
  );
}

function MetricsDashboard({ data }) {
  const getSeries = (id) => {
    const item = data.find((d) => d.Id === id);
    if (!item) return { timestamps: [], values: [] };

    return {
      timestamps: item.Timestamps,
      values: item.Values,
    };
  };

  const cpu = getSeries("cpuUtilization");
  const cpuMem = getSeries("cpuMemory");
  const gpu = getSeries("gpuUtilization");
  const gpuMem = getSeries("gpuMemoryUsedPercent");

  const chartConfig = (labels, values) => ({
    series: [
      {
        name: "value",
        data: labels.map((t, i) => ({
          x: new Date(t).toLocaleTimeString([], {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }),
          y: values[i],
        })),
      },
    ],
    options: {
      chart: {
        height: 148,
        type: "line",
        toolbar: { show: false },
      },
      stroke: { curve: "smooth", width: 2 },
      grid: {
        padding: {
          bottom: -20,
        },
        xaxis: {
          lines: { show: false },
        },
      },
      xaxis: {
        type: "time",
        axisBorder: { show: false },
        axisTicks: { show: false },

        labels: {
          show: false,
          style: { fontSize: "10px" },

          // formatter: (value, timestamp, opts) => {
          //   if (!opts) return "";

          //   const labels = opts.w.globals.labels;
          //   const index = labels.indexOf(value);
          //   console.log(opts);

          //   // ✅ show only first & last
          //   if (index !== 0 && index !== labels.length - 1) return "";

          //   const d = new Date(value);
          //   return `${d.getDate().toString().padStart(2, "0")}-${(
          //     d.getMonth() + 1
          //   )
          //     .toString()
          //     .padStart(2, "0")}-${d
          //     .getFullYear()
          //     .toString()
          //     .slice(-2)}, ${d.toLocaleTimeString("en-US", {
          //     hour: "2-digit",
          //     minute: "2-digit",
          //     hour12: true,
          //   })}`;
          // },
        },
      },
      yaxis: { decimalsInFloat: 0 },
      // tooltip: { theme: "dark" },
      tooltip: {
        // x: {
        //   formatter: (value) => {
        //     const d = new Date(value);
        //     return `${d.getDate().toString().padStart(2, "0")}-${(
        //       d.getMonth() + 1
        //     )
        //       .toString()
        //       .padStart(2, "0")}-${d
        //       .getFullYear()
        //       .toString()
        //       .slice(-2)}, ${d.toLocaleTimeString("en-US", {
        //       hour: "2-digit",
        //       minute: "2-digit",
        //       hour12: true,
        //     })}`;
        //   },
        // },
      },
    },
  });

  return (
    <div className="grid grid-cols-2 gap-2">
      {/* CPU Utilization */}
      <Card className="border rounded-xl py-2 pt-4 gap-0">
        <CardHeader className="px-4">
          <CardTitle>CPU Utilization</CardTitle>
        </CardHeader>
        <CardContent className="px-2">
          <Chart
            options={chartConfig(cpu.timestamps, cpu.values).options}
            series={chartConfig(cpu.timestamps, cpu.values).series}
            type="line"
            height={148}
          />
        </CardContent>
      </Card>

      {/* CPU Memory Used Percentage */}
      <Card className="border rounded-xl py-2 pt-4 gap-0">
        <CardHeader className="px-4">
          <CardTitle>CPU Memory Used %</CardTitle>
        </CardHeader>
        <CardContent className="px-2">
          <Chart
            options={chartConfig(cpuMem.timestamps, cpuMem.values).options}
            series={chartConfig(cpuMem.timestamps, cpuMem.values).series}
            type="line"
            height={148}
          />
        </CardContent>
      </Card>

      {/* GPU Utilization */}
      <Card className="border rounded-xl py-2 pt-4 gap-0">
        <CardHeader className="px-4">
          <CardTitle>GPU Utilization</CardTitle>
        </CardHeader>
        <CardContent className="px-2">
          <Chart
            options={chartConfig(gpu.timestamps, gpu.values).options}
            series={chartConfig(gpu.timestamps, gpu.values).series}
            type="line"
            height={148}
          />
        </CardContent>
      </Card>

      {/* GPU Memory Used Percentage */}
      <Card className="border rounded-xl py-2 pt-4 gap-0">
        <CardHeader className="px-4">
          <CardTitle>GPU Memory Used %</CardTitle>
        </CardHeader>
        <CardContent className="px-2">
          <Chart
            options={chartConfig(gpuMem.timestamps, gpuMem.values).options}
            series={chartConfig(gpuMem.timestamps, gpuMem.values).series}
            type="line"
            height={148}
          />
        </CardContent>
      </Card>
    </div>
  );
}
